/* global CONTENT_BRANCH APP_NAME */
module.exports.P4_RELAY_URL = `https://localhost:43115/${CONTENT_BRANCH}/${APP_NAME}`;



// WEBPACK FOOTER //
// ./lib/rlink-p4/constants.js